import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import { MY_DAY_TODAYS_LESSONS_ROUTE } from '../../services/routes';
import MyDayContentCard from './my_day_content_card';
import { useGetSharedProgrammeQuery } from '../../app/smorgAppSyncGraphQLApi';
import {
  getContentEntriesForCalendarDay,
  programmeStartCalendarDay,
} from '../../services/my_day';
import { useCurrentProgrammeEnrollmentQuery } from '../../app/smorgAppSyncGraphQLApiCustomHooks';
import MyDayPlaceholderSection from './my_day_placeholder_section';
import MyDayPlaceholderCard from './my_day_placeholder_card';
import { SHARED_PROGRAMMES_REFRESH_INTERVAL_SECONDS } from '../../services/end_user_published_resources';

const MyDayTodaysLessonsSection = ({ today }) => {
  const { data: currentProgrammeEnrollment, isLoading: isEnrollmentLoading } =
    useCurrentProgrammeEnrollmentQuery();

  const programmeStartDay = programmeStartCalendarDay(
    currentProgrammeEnrollment,
  );

  const { sharedProgrammeID } = currentProgrammeEnrollment || {};

  const { data: sharedProgramme, isLoading: isSharedProgrammeLoading } =
    useGetSharedProgrammeQuery(sharedProgrammeID, {
      skip: !sharedProgrammeID,
      refetchOnMountOrArgChange: SHARED_PROGRAMMES_REFRESH_INTERVAL_SECONDS,
    });

  const todaysProgrammeEntriesOfTypeContentFromSharedProgramme =
    (programmeStartDay &&
      sharedProgramme &&
      getContentEntriesForCalendarDay(
        sharedProgramme,
        programmeStartDay,
        today,
      )) ||
    [];

  console.log(
    `${todaysProgrammeEntriesOfTypeContentFromSharedProgramme.length} todays content cards`,
  );

  const hasLoadedSuccessfully = !isEnrollmentLoading && !isSharedProgrammeLoading;

  if (!hasLoadedSuccessfully) {
    return <MyDayPlaceholderSection title="Loading lessons..." />;
  }

  if (
    hasLoadedSuccessfully &&
    todaysProgrammeEntriesOfTypeContentFromSharedProgramme.length === 0
  ) {
    return null;
  }

  return !hasLoadedSuccessfully ? (
    <MyDayPlaceholderCard />
  ) : (
    <>
      <Grid container>
        <Grid item xs={8}>
          <h2
            style={{
              margin: '23px 23px 5px',
              color: 'var(--app-primary-font-color)',
            }}>
            Today&apos;s lessons
          </h2>
        </Grid>
        <Grid
          item
          xs={4}
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}>
          <Box sx={{ margin: '28px 10px 5px' }}>
            <Link to={MY_DAY_TODAYS_LESSONS_ROUTE}>View all</Link>
          </Box>
        </Grid>
      </Grid>

      <div style={{ overflowX: 'auto', display: 'flex' }}>
        {todaysProgrammeEntriesOfTypeContentFromSharedProgramme.map(
          (programmeEntry) => (
            <div key={programmeEntry.objectID} style={{ flexShrink: 0 }}>
              <MyDayContentCard
                contentEntryID={programmeEntry.objectID}
                parentID={sharedProgrammeID}
                calendarDay={today}
              />
            </div>
          ),
        )}
      </div>
    </>
  );
};

MyDayTodaysLessonsSection.propTypes = {
  today: PropTypes.string.isRequired,
};

export default MyDayTodaysLessonsSection;
